import { Component, ViewEncapsulation } from '@angular/core';
import { PageBannerService } from 'Src/ng2/shared/components/page-banner/page-banner.service';
import { IPageBannerMeta } from 'Src/ng2/shared/components/page-banner/page-banner.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'standard-layout',
  templateUrl: './standard-layout.component.html',
  styleUrls: ['./standard-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StandardLayoutComponent {
  public pageBannerMeta: IPageBannerMeta;
  private titleSubscription: Subscription;

  constructor (
    private pageBannerService: PageBannerService,
  ) {}

  ngOnInit (): void {
    this.titleSubscription = this.pageBannerService
      .getPageBannerMeta()
      .subscribe(meta => {
        this.pageBannerMeta = meta;
      });
  }

  ngOnDestroy (): void {
    if (this.titleSubscription) {
      this.titleSubscription.unsubscribe();
    }
  }
}
